import React, { useState } from "react";
import { Avatar, Button, Divider, Layout, Row, Typography, Tag   } from "antd";
import Swal from "sweetalert2";
import {
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    LogoutOutlined
} from '@ant-design/icons';
import { inject, observer } from 'mobx-react'
import './styles.scss'

const { Header } = Layout;
const { Text, Link } = Typography;

const HeaderNav = ({ collapsed, setCollapsed, userStore }) => {

    const user = JSON.parse(localStorage.getItem("dXNlclN0b3Jl"));
    const username = user && user.username;
    const name = user && user.fullName;

    const showConfirmLogout = () => {
        Swal.fire({
            title: "Logging Out Safely",
            icon: "question",
            text: "Are you sure do you want to log out?",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: `Cancel`
        }).then((result) => {
            if (result.isConfirmed) {
                localStorage.removeItem("dXNlclN0b3Jl");
                localStorage.removeItem("QUNDRVNTX1RPS0VO");
                localStorage.removeItem("topUpTeamLeaders");
                window.location.href = '/login'
            } 
        })
    }

    return (
        <Header
            style={{
                padding: 0,
                background: '#FFF',
            }}
        >
            <Row justify={'space-between'}>
                <Button
                    type="text"
                    icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                    onClick={() => setCollapsed(!collapsed)}
                    style={{
                        fontSize: '16px',
                        height: '64px',
                        width: '64px',
                    }}
                />
                <Row align={'middle'}>
                    <div className="header-avatar"><Avatar  size="large" gap={2}>{(name.charAt(0)).toUpperCase()}</Avatar></div>
                    <Divider className="remove-when-mobile" type="vertical"/>
                    <div className="user-info">
                        <p>{name}</p>
                        <Link>@{username} 🚀</Link>
                    </div>
                    <div className="logout-btn">
                        <Button onClick={showConfirmLogout} icon={<LogoutOutlined />} ></Button>
                    </div>
                </Row>
                
            </Row>
            
        </Header>
    );
};

export default inject('userStore')(observer(HeaderNav));